export default {
  data () {
    return {
      filters: [],
      currentPage: 1,
      totalRows: 1,
      perPage: 10
    }
  },
  methods: {
    getEmptyStringOrLowerCase (text) {
      if (text === undefined || text === null) {
        return ''
      }
      return text.toString().toLowerCase()
    }
  },
  computed: {
    elementsFiltered () {
      let filters = this.filters
      let app = this
      let filtered = this.elements.filter((element) => {
        let isVisible = true
        Object.keys(filters).forEach(function (key) {
          let value = app.getEmptyStringOrLowerCase(filters[key])
          if (value !== '') {
            let elementVal = app.getEmptyStringOrLowerCase(element[key])
            if (!elementVal.includes(value)) {
              isVisible = false
            }
          }
        })
        return isVisible
      })
      return filtered
    }
  },
  watch: {
    'elementsFiltered' () {
      this.totalRows = this.elementsFiltered.length
      this.currentPage = 1
    }
  }
}
